module.exports = __webpack_public_path__ + "static/media/shield-check-filled.54d925d2.svg";